import React from 'react';

import { useApp } from '../../store/AppContext';

export default function ViewAsSelect() {
  const { teamDevs, profile, session, startViewAs } = useApp();
  return (
    <select
      className="input select w-[100%] text-[11.5px]"
      value=""
      onChange={(e) => {
        if (e.target.value) startViewAs(e.target.value);
      }}
      title="Aperçu lecture seule de l'interface d'un dev"
    >
      <option value="">👁 Voir en tant que…</option>
      {teamDevs
        .filter(
          (d) =>
            d.id !== (profile?.dev_id || session?.user?.id) &&
            /^[0-9a-f]{8}-[0-9a-f]{4}-/.test(d.id),
        )
        .map((d) => (
          <option key={d.id} value={d.id}>
            {d.nom}
          </option>
        ))}
    </select>
  );
}
